import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const DeleteLeadDialog = ({ name, onConfirm, deleting, children, testIdSuffix = "" }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
    <AlertDialogContent data-testid={`delete-confirm-dialog${testIdSuffix}`} onClick={(e) => e.stopPropagation()}>
      <AlertDialogHeader>
        <AlertDialogTitle>Eliminare la scheda?</AlertDialogTitle>
        <AlertDialogDescription>
          Questa azione è irreversibile. La scheda di{" "}
          <span className="font-semibold text-buscema-green">{name || "questo contatto"}</span>{" "}
          verrà rimossa definitivamente.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="delete-cancel-btn">Annulla</AlertDialogCancel>
        <AlertDialogAction
          data-testid="delete-confirm-btn"
          onClick={onConfirm}
          disabled={deleting}
          className="bg-red-600 hover:bg-red-700 text-white"
        >
          {deleting ? "Eliminazione..." : "Elimina"}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
